var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledThumsup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03418 13.6562H7.07174C7.44798 13.6562 7.60592 13.8992 7.60592 14.0319V28.4924C7.60592 28.6251 7.44798 28.8681 7.07174 28.8681H1.03418C0.657935 28.8681 0.5 28.6251 0.5 28.4924V14.0319C0.5 13.8992 0.657936 13.6562 1.03418 13.6562Z",
    fill: "url(#paint0_linear_13_83266)",
    stroke: "#CC790A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1905 18.4845L33.1904 18.4845L24.5672 17.132C24.5671 17.132 24.5671 17.132 24.567 17.132C23.7292 17.0003 23.1359 16.1913 23.2685 15.3093C23.4007 14.4301 24.2002 13.8443 25.0358 13.9756L25.0589 13.9792L25.0822 13.9807L33.635 14.5158C33.9475 14.5757 34.3181 14.9048 34.6105 15.484C34.8993 16.0562 35.0243 16.7084 34.9578 17.1508C34.8256 18.03 34.0261 18.6158 33.1905 18.4845Z",
    fill: "url(#paint1_linear_13_83266)",
    stroke: "#CC790A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5492 21.8059L23.5491 21.8058C22.7285 21.6307 22.1849 20.7996 22.3613 19.936C22.5369 19.0765 23.3548 18.5423 24.1729 18.7169L24.1813 18.7186L24.1897 18.7201L32.8428 20.2585C33.1937 20.3363 33.4822 20.5986 33.6686 21.0059C33.8576 21.4189 33.9152 21.9338 33.8212 22.394C33.6456 23.2534 32.8277 23.7877 32.0096 23.6131L23.5492 21.8059Z",
    fill: "url(#paint2_linear_13_83266)",
    stroke: "#CC790A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.741 28.6892L22.5251 26.5997L22.5158 26.5974L22.5065 26.5954C21.6996 26.4228 21.1648 25.6057 21.3368 24.7557C21.5101 23.9107 22.3143 23.3855 23.1189 23.5557C23.119 23.5557 23.1192 23.5557 23.1193 23.5557L31.471 25.3394C31.4711 25.3394 31.4711 25.3394 31.4712 25.3394C32.2779 25.5121 32.8127 26.3292 32.6406 27.1791C32.5516 27.6132 32.2804 28.0517 31.9172 28.3534C31.5534 28.6556 31.1542 28.7776 30.8041 28.7027L30.741 28.6892Z",
    fill: "url(#paint3_linear_13_83266)",
    stroke: "#CC790A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1228 28.2668L29.506 30.2378C29.5063 30.2378 29.5065 30.2379 29.5068 30.238C30.2476 30.4389 30.705 31.2234 30.5034 32.0019C30.419 32.3278 30.06 32.7302 29.5205 33.0303C28.99 33.3255 28.4536 33.4275 28.125 33.3453L21.4432 31.0634L21.4279 31.0582L21.4122 31.054C20.6709 30.8534 20.2131 30.0685 20.4148 29.2898C20.6158 28.5136 21.3854 28.0673 22.1212 28.2664L22.1228 28.2668Z",
    fill: "url(#paint4_linear_13_83266)",
    stroke: "#CC790A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1863 12.4194C26.2302 12.4007 26.2869 12.376 26.3538 12.346C26.5243 12.2695 26.7595 12.1589 27.0176 12.0227C27.5491 11.7422 28.1207 11.3826 28.4525 11.018C28.8081 10.6274 28.9551 10.3608 29.2242 9.8725C29.2439 9.83683 29.2642 9.79997 29.2853 9.7618C29.5599 9.26492 29.5774 8.9789 29.6071 8.49184C29.6203 8.27643 29.6359 8.02169 29.6771 7.69199C29.764 6.99802 29.6366 6.5666 29.4497 5.93341C29.3843 5.71177 29.3115 5.46541 29.2381 5.17441C29.135 4.76553 29.0178 4.27892 28.9266 3.89566C28.881 3.70378 28.8417 3.53734 28.8139 3.41884L28.7813 3.27979L28.7787 3.26871L28.7776 3.26598C28.7672 3.24081 28.7513 3.20313 28.7304 3.15493C28.6885 3.05845 28.6266 2.92031 28.5477 2.75641C28.389 2.42673 28.1655 2.00138 27.9018 1.60314C27.6328 1.19689 27.3465 0.856987 27.0722 0.662331C26.8087 0.475284 26.6394 0.47197 26.4957 0.544432C26.3359 0.625014 26.1338 0.822658 25.9472 1.05241C25.8606 1.15899 25.7881 1.25892 25.7374 1.33211C25.7328 1.33863 25.7285 1.34491 25.7244 1.35096C25.7223 1.37073 25.72 1.39259 25.7174 1.41646C25.7042 1.53917 25.6833 1.71501 25.6528 1.93086C25.592 2.36193 25.4921 2.95588 25.3361 3.60681C25.0309 4.87984 24.4862 6.48149 23.5108 7.45096C22.9618 7.99665 22.2031 8.44336 21.5801 8.76223C21.2636 8.92419 20.972 9.05812 20.7457 9.15916C20.6482 9.20269 20.5691 9.23742 20.5065 9.26497C20.4112 9.30684 20.3538 9.33209 20.3267 9.34634L20.3265 9.34642C20.3275 9.3459 20.328 9.34562 20.328 9.34563C20.328 9.34568 20.3191 9.3508 20.2976 9.36483C20.2738 9.3803 20.2423 9.40166 20.2025 9.4294C20.1232 9.48478 20.0189 9.56014 19.8921 9.65354C19.639 9.84003 19.3049 10.0923 18.9188 10.3871C18.1472 10.9765 17.1746 11.7312 16.2418 12.4598L16.2417 12.4599C15.1586 13.3054 13.3364 13.9247 11.856 14.3287C11.1025 14.5344 10.4132 14.6904 9.91235 14.7951C9.7588 14.8271 9.62277 14.8544 9.50781 14.8769V27.6625H10.393C12.1857 27.6625 13.9536 28.0765 15.5674 28.8693L15.5677 28.8695L18.8493 30.485C18.72 30.082 18.6685 29.655 18.6988 29.2312M26.1863 12.4194L20.8932 21.7212C20.9541 21.8489 21.0223 21.972 21.0974 22.0899C20.9841 22.166 20.8747 22.2499 20.7695 22.3413C20.343 22.7082 20.0186 23.1844 19.8295 23.7173C19.4585 24.7625 19.6254 25.8428 20.161 26.6799C19.3486 27.225 18.776 28.135 18.6988 29.2312M26.1863 12.4194L25.2713 12.3591L25.2634 12.3586L25.2555 12.3583C24.3616 12.328 23.4563 12.4707 22.6595 13.1527C22.224 13.523 21.8946 14.0075 21.7032 14.5475L21.7031 14.5478C21.3342 15.5909 21.5031 16.6684 22.037 17.5028M26.1863 12.4194L22.037 17.5028M18.6988 29.2312C18.6988 29.2313 18.6988 29.2314 18.6988 29.2315L19.1976 29.2665L18.6988 29.2308C18.6988 29.2309 18.6988 29.2311 18.6988 29.2312ZM22.037 17.5028C21.2207 18.0511 20.6451 18.9707 20.5746 20.0764L20.5745 20.0773C20.5395 20.6422 20.6497 21.2123 20.8931 21.7208L22.037 17.5028Z",
    fill: "url(#paint5_linear_13_83266)",
    stroke: "#CC790A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_83266",
    x1: 4.00697,
    y1: 14.3731,
    x2: 4.00697,
    y2: 29.3632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9750B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_83266",
    x1: 29.0404,
    y1: 13.8733,
    x2: 29.0404,
    y2: 19.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9750B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_83266",
    x1: 28.0257,
    y1: 18.6312,
    x2: 28.0257,
    y2: 24.1446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9750B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_83266",
    x1: 26.9186,
    y1: 23.4889,
    x2: 26.9186,
    y2: 29.2226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9750B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13_83266",
    x1: 25.3957,
    y1: 28.1807,
    x2: 25.3957,
    y2: 33.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9750B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13_83266",
    x1: 19.4856,
    y1: 2.3396,
    x2: 19.4856,
    y2: 31.1594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9750B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledThumsup);
export default __webpack_public_path__ + "static/media/filled-thumsup.b34207ec4facbf0c5325480a63a03434.svg";
export { ForwardRef as ReactComponent };